export default function removeTopDiv(content){
    return content.replace(/<div[^>]*>([\s\S]*)<\/div>/ig, "$1");
}